import { takeLatest, all } from 'redux-saga/effects';
import apiSaga from 'legacy/src/shared/util/apiSagaGenerator';

import { fetchSubmissionData } from './actions';

export function* fetchSubmissionDataSaga({ payload: assignmentId }) {
  yield apiSaga(fetchSubmissionData, {
    url: `assessments/api/assignments/${assignmentId}/submissions/`,
  });
}

export default function* submissionDataSaga() {
  yield all([takeLatest(fetchSubmissionData.TRIGGER, fetchSubmissionDataSaga)]);
}
